export default __webpack_public_path__ + "static/events-light-ad5ec5e49d962f87c942156b856bd666.png";